<template>
  <span :endTime="endTime" :endText="endText" v-if="loading">
    {{ countDownList }}
  </span>
</template>

<script>
export default {
  data() {
    return {
      countDownList: "00天00时00分00秒",
      actEndTime: "2018-11-19 18:50:00",
      loading: false,
    };
  },
  props: {

    endTime: {
      type: Number,
      default: ""
    },
    endText: {
      type: String,
      default: "00:00:00"
    },
  },
  created() {
    this.countDown();
  },

  methods: {
    timeFormat(param) {
      return param < 10 ? "0" + param : param;
    },
    countDown(it) {
      var interval = setInterval(() => {
        // 获取当前时间，同时得到活动结束时间数组
        let startTime = (new Date()).getTime(); // 对结束时间进行处理渲染到页面
        let endTime = this.endTime * 1000;
        let obj = null; // 如果活动未结束，对时间进行处理
        if (endTime - startTime > 0) {
          let time = (endTime - startTime) / 1000; // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt((time % (60 * 60 * 24)) / 3600);
          let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          obj = {
            day: this.timeFormat(day),
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };
          this.countDownList =
            obj.day + "天" + obj.hou + ":" + obj.min + ":" + obj.sec;
          this.loading = true;
        } else {
          // 活动已结束，全部设置为'00'
          this.countDownList = this.endText;
          this.countDownList = clearInterval(interval);
          this.loading = true
        }
      }, 1000);
    }
  }
};
</script>

<style scoped></style>
